import apiClient from './index';
import { ApartmentBuildingSummaryResponse } from './types';

export type ApartmentInDB = {
  id: string;
  corp_id: string;
  created_at: string;
  number: string;          // № помещения
  suffix?: string | null;  // суффикс
  area?: string | null;    // площадь (строкой по API)
  floor_number?: string | null;
  section_number?: string | null;
  owner_name?: string | null;
  account_number?: string | null;
  manual_registration_notes?: string | null;
  heat_accounting_mode?: string | null;
  heat_calculate_by_area?: boolean;
  heat_room_coefficient?: number | null;
  heat_expected_radiator_count?: number | null;
  heat_room_type?: string | null;
  heat_move_in_date?: string | null;
};

export type ApartmentOverviewDevice = {
  id: string;
  name?: string | null;
  serial_number?: string | null;
  system_type?: string | null;
  status?: string | null;
  manufacturer?: string | null;
  seal_date?: string | null;
  verification_date?: string | null;
  dev_eui?: string | null;
  mqtt_topic?: string | null;
  decoder?: string | null;
  last_seen_at?: string | null;
  lorawan_enabled?: boolean;
  lorawan_sync_status?: string | null;
  lorawan_last_sync_at?: string | null;
  lorawan_sync_error?: string | null;
  lorawan_signal_rssi?: number | null;
  lorawan_signal_snr?: number | null;
  lorawan_gateways_count?: number | null;
  latest_reading_value?: number | null;
  latest_reading_ts?: string | null;
  latest_reading_source?: string | null;
  latest_components?: Record<string, number | null> | null;
  heat_coefficient?: number | null;
  heat_reduction_coefficient?: number | null;
  heat_is_direct?: boolean;
  heat_archived?: boolean;
  heat_removal_date?: string | null;
  replacements_count?: number;
  latest_replacement_at?: string | null;
  latest_replacement_reason?: string | null;
  documents_count?: number;
  bus_agent_connected?: boolean;
  bus_agent_online?: boolean;
  bus_agent_name?: string | null;
};

export type ApartmentOverviewTicket = {
  id: string;
  number: number;
  title: string;
  status: string;
  priority: string;
  category?: string | null;
  source?: string | null;
  due_at?: string | null;
  created_at?: string | null;
};

export type ApartmentOverview = {
  apartment: ApartmentInDB;
  building_id: string;
  building_name?: string | null;
  corp_id: string;
  corp_name?: string | null;
  corp_is_default?: boolean;
  display_number: string;
  devices: ApartmentOverviewDevice[];
  tickets: ApartmentOverviewTicket[];
  counters: {
    devices_total: number;
    devices_online: number;
    devices_without_readings: number;
    tickets_open: number;
    tickets_overdue: number;
  };
};

export type ApartmentCreate = {
  corp_id: string;
  number: string;
  floor_number?: string;
  suffix?: string;
  area?: string;
  section_number?: string;
  owner_name?: string;
  account_number?: string;
  manual_registration_notes?: string;
  heat_accounting_mode?: string;
  heat_calculate_by_area?: boolean;
  heat_room_coefficient?: number;
  heat_expected_radiator_count?: number;
  heat_room_type?: string;
  heat_move_in_date?: string;
};

export type ApartmentUpdate = ApartmentCreate;

export const apartmentsApi = {
  async getAll(): Promise<ApartmentInDB[]> {
    const res = await apiClient.get<ApartmentInDB[]>('/apartments/');
    return res.data;
  },

  async getByCorp(corpId: string): Promise<ApartmentInDB[]> {
    const res = await apiClient.get<ApartmentInDB[]>(`/apartments/by-corp/${corpId}`);
    return res.data;
  },

  async getBuildingSummary(buildingId: string): Promise<ApartmentBuildingSummaryResponse> {
    const res = await apiClient.get<ApartmentBuildingSummaryResponse>(
      `/apartments/by-building/${buildingId}/summary`
    );
    return res.data;
  },

  async create(data: ApartmentCreate): Promise<ApartmentInDB> {
    const res = await apiClient.post<ApartmentInDB>('/apartments/', data);
    return res.data;
  },

  async getById(id: string): Promise<ApartmentInDB> {
    const res = await apiClient.get<ApartmentInDB>(`/apartments/${id}`);
    return res.data;
  },

  async getOverview(id: string): Promise<ApartmentOverview> {
    const res = await apiClient.get<ApartmentOverview>(`/apartments/${id}/overview`);
    return res.data;
  },

  async update(id: string, data: ApartmentUpdate): Promise<ApartmentInDB> {
    const res = await apiClient.put<ApartmentInDB>(`/apartments/${id}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/apartments/${id}`);
  },
};
